import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type { ClientAppCardsResponseData } from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const clientAppCardKeys = {
  all: () => ['clientAppCards'] as const,
  list: (props: { url: string }) =>
    [...clientAppCardKeys.all(), 'list', props.url] as const,
};

export const clientAppCardQueries = {
  list: (props: { url: string }) =>
    queryOptions({
      queryKey: clientAppCardKeys.list(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<ClientAppCardsResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),
};
